// extracted by mini-css-extract-plugin
export default {"botones":"Paginacion_botones__Be3aF","boton":"Paginacion_boton__xbeXO"};